<template>
    <ion-card-title class="title px-8 interstate" color="primary"> {{ title.toUpperCase() }} </ion-card-title>
    <div class="scroll-wrapper">
        <ion-row class="expand-row" style="padding-bottom: 20px">
            <ion-col size-xs="8" size-sm="6" size-md="4" class="order-card-col" v-for="(order, index) in orderHistory" :key="index">
                <ion-card style="margin-inline: 5px; padding-bottom: 20px" mode="ios">
                    <ion-card-content class="ion-text-center">
                        <div v-for="(item, index) in order.items.slice(0, 3)" :key="index" class="pb-4">
                            <ion-text class="interstate-bold ion-text-center" style="font-size: 1.1em"> {{ item.nameDisplay }} </ion-text><br />
                            <ion-text class="ion-text-center" style="font-size: 0.9em">{{ item.description }}</ion-text>
                        </div>
                    </ion-card-content>

                    <ion-row class="d-flex" style="flex-direction: column; align-content: center; align-items: center">
                        <ion-button shape="round" style="font-weight: bold; --box-shadow: 0px 5px 5px gray" @click="repeatOrder(order)"> Add to cart </ion-button>
                    </ion-row>
                </ion-card>
            </ion-col>
        </ion-row>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonRow, IonCol, IonCard, IonCardContent, IonCardTitle, IonButton, IonText } from '@ionic/vue';

import { HistoryOrder } from '@/models/cartModels';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default defineComponent({
    props: { title: { type: String, default: 'Order Again' } },
    components: { IonRow, IonCol, IonCard, IonCardContent, IonCardTitle, IonButton, IonText },
    setup() {
        const store = useStore();
        const router = useRouter();

        const orderHistory = computed((): HistoryOrder[] => store.getters.getOrderHistory.slice(0, 3));
        const repeatOrder = (order: HistoryOrder) => store.dispatch('addOrderToCart', order).then(() => router.push('/cart'));

        return { repeatOrder, orderHistory };
    },
});
</script>

<style scoped>
.scroll-wrapper {
    overflow-x: scroll;
}
.expand-row {
    flex-wrap: unset;
    display: flex;
}
.item-col:not(:last-child) {
    margin-right: 8px;
}

ion-card-content {
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.title {
    padding-top: 12px;
    margin-bottom: -20px;
    font-size: 28px;
    font-weight: bold;
}

@media screen and (min-width: 960px) {
    ion-col.order-card-col {
        flex: 0 0 260px !important;
        width: 260px !important;
        max-width: 260px !important;
    }
}
</style>
